import React from 'react';

import {
  Box,
  ImageList,
  ImageListItem,
  Link,
  Stack,
  styled,
  Typography,
  useTheme,
} from '@mui/material';
import { DocumentDownload, Eye } from 'iconsax-reactjs';
import { useTranslation } from 'react-i18next';

const ImageListStyled = styled(ImageList)(({ isOpen }: { isOpen?: boolean }) => ({
  ...(isOpen && {
    gridTemplateColumns: 'repeat(2, 50%) !important',
  }),
}));

const PreviewBoxStyled = styled(Link)({
  position: 'absolute',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.03)',
  display: 'none',
  justifyContent: 'center',
  borderRadius: '8px',
  alignItems: 'center',
  '.MuiImageListItem-root:hover > &': {
    display: 'flex',
  },
});

interface IProps {
  cv: string | null;
  images: string[] | null;
  isOpen?: boolean;
}

const CvPreview = React.memo(({ cv, images, isOpen }: IProps) => {
  const { t } = useTranslation();

  const theme = useTheme();

  return (
    <Stack spacing={1}>
      <Stack>
        {images?.length && (
          <ImageListStyled cols={1} isOpen={isOpen && images?.length > 1}>
            {images.map((image) => (
              <ImageListItem key={image} sx={{ position: 'relative', borderRadius: '8px' }}>
                <img src={image} alt={image} loading="lazy" />

                <PreviewBoxStyled href={image} target="_blank" rel="noreferrer">
                  <Eye size={20} color={theme.palette.primary.main} />
                </PreviewBoxStyled>
              </ImageListItem>
            ))}
          </ImageListStyled>
        )}
      </Stack>

      {cv && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Link
            href={cv}
            target="_blank"
            rel="noreferrer"
            underline="hover"
            sx={{ color: `${theme.palette.primary.main} !important` }}
          >
            <Typography variant="body1" color="primary" fontWeight={700}>
              <DocumentDownload size={14} color={theme.palette.primary.main} />

              <Box component="span" sx={{ marginLeft: theme.spacing(0.5) }}>
                {t('buttons.download')}
              </Box>
            </Typography>
          </Link>
        </Box>
      )}
    </Stack>
  );
});

export default CvPreview;
